export default "__VITE_ASSET__DR8l9ezD__"